import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux/hooks';
import { apiKeyState, listApiKeys } from '../apiKeySlice';
import { ApiKeyDisplay } from '../models/ApiKey.interface';


export const useApiKeys = (): [boolean, boolean, ApiKeyDisplay[]] => {
    const dispatch = useAppDispatch();
    const { list: { isLoading, isError, isSuccess, apiKeys } } = useAppSelector(apiKeyState);
    useEffect(() => {
        if (isSuccess) {
            return
        }
        if (isError) {
            return;
        }

        if (!isLoading && !isSuccess) {
            dispatch(listApiKeys());
        }
    }, [isLoading, isError, isSuccess, dispatch]);

    return [isLoading, isError, apiKeys]
}
